import { setLetterSpacingVar, removeCssVar } from '../utils/domHelpers';
import { CSS_VARS } from '../utils/constants';
import { LETTER_SPACINGS } from '../config/settings';

export function applyLetterSpacing(index) {
  if (index >= 0 && index < LETTER_SPACINGS.length) {
    const val = LETTER_SPACINGS[index].value;
    setLetterSpacingVar(val || '');
  }
}

export function removeLetterSpacing() {
  removeCssVar(CSS_VARS.letterSpacing);
}
